import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/hooks/useLanguage';
import { Check, Globe } from 'lucide-react';
import {
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
  DropdownMenuItem,
} from '@scio3/ui';

export function LanguageSwitcher() {
  const { t } = useTranslation();
  const { language, setLanguage, languages } = useLanguage();

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Globe className="mr-2 h-4 w-4" />
        {t('Language')}
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        {languages.map((lang) => (
          <DropdownMenuItem key={lang.key} onClick={() => setLanguage(lang.key)}>
            {lang.key === language && <Check className="mr-2 h-4 w-4" />}
            {lang.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
}
